import React, { useState, useEffect, useRef, lazy, Suspense, useCallback } from "react";
import { Form, Modal, Tabs, Tab, Row, Col } from "react-bootstrap";
import axios from "axios";
import config from "../../../../../config/config.json";
import { apiCall } from "../../../../../_services/apiCall";
import './dashboardheader.css'
import MultiSelect from "../../../Component/CommonComponent/MultiSelect";
import { LocationField, PeriodsField } from "../../../../CarbonFootPrinting/common/FormComponents";
import { useCurrentUser } from "../../../../../hooks/useCurrentUser";
import ModuleReportTemplateSelector from "./ModuleReportTemplateSelector";

const CompareTab = lazy(() => import("../../../Component/ESGDownload/compareToPreviousYear"));

const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const STATIC_REPORT_TEMPLATE_OPTIONS = [{ value: "BRSR", label: "BRSR", isStatic: true }];

const buildReportTemplateOptionsFromFilters = (graphFilters = {}) => {
  const moduleTemplateMap = {
    Energy: [{ value: "ENERGY", label: "Energy" }],
    Waste: [{ value: "WASTE", label: "Waste" }],
    Water: [{ value: "WATER", label: "Water" }],
    Diversity: [{ value: "DIVERSITY", label: "Diversity" }],
    Employment: [{ value: "EMPLOYMENT", label: "Employment" }],
    Occupancy: [{ value: "OCCUPANCY", label: "Occupancy" }],
    "Health & Safety": [{ value: "HEALTH_SAFETY", label: "Health & Safety" }],
    "Health and Safety": [{ value: "HEALTH_SAFETY", label: "Health & Safety" }],
    Training: [{ value: "TRAINING", label: "Training" }],
    Governance: [{ value: "GOVERNANCE", label: "Governance" }],
    Emission: [
      { value: "SCOPE1", label: "Scope 1" },
      { value: "SCOPE2", label: "Scope 2" },
    ],
  };

  const dynamicOptions = Object.keys(graphFilters)
    .filter((key) => key !== "Financial Years" && key !== "Location")
    .flatMap((moduleName) => moduleTemplateMap[moduleName] || [])
    .filter((option, index, arr) => arr.findIndex((item) => item.value === option.value) === index);

  return [...STATIC_REPORT_TEMPLATE_OPTIONS, ...dynamicOptions];
};
const energyCategoryOptions = [
  { value: "Fuel Consumption", label: "Fuel Consumption" },
  { value: "Energy Consumption", label: "Energy Consumption" },
  { value: "Electricity Consumption", label: "Electricity" },
];

const normalizeReportPeriodForApi = (period) =>
  String(period || "")
    .trim()
    .replace(/\s*-\s*/g, "–")
    .replace(/[—-]/g, "–");

const DashboardHeader = ({
  tabs,               
  currentTab,         
  setCurrentTab,      
  setFinancialYearId,
  graphSearchTerm,    
  setGraphSearchTerm, 
  setShow,
  financialYear,
  frameworkValue,
  setFinancialYear,
  setTimePeriods,
  keyTab,
  setKeyTab,
  setLocationOption,
  setFramework,
  framework,
  downloadPdf,
  setFromDate,
  setToDate,
  show,
  handleClose,
  financialYearId,
  setcompareLastTimePeriods,
  setcompareCurrentTimePeriods,
  compareLastTimePeriods,
  compareTCurrentimePeriods,
  handleModal
}) => {
  const { startingMonth, frequency: Userfrequency, companyId } = useCurrentUser();
  const start = startingMonth || null;

  const [selectedPeriod, setSelectedPeriod] = useState([]);
  const [synceLoading, setSynceLoading] = useState(false);
  const [meterList, setMeterList] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [showFilter, setShowFilter] = useState(false);
  const [showScopeOneModal, setShowScopeOneModal] = useState(false);
  const [showScopeTwoModal, setShowScopeTwoModal] = useState(false);
  const [showEnergyModal, setShowEnergyModal] = useState(false);
  const [showWasteModal, setShowWasteModal] = useState(false);
  const [scopeOneLoading, setScopeOneLoading] = useState(false);
  const [scopeTwoLoading, setScopeTwoLoading] = useState(false);
  const [energyLoading, setEnergyLoading] = useState(false);
  const [wasteLoading, setWasteLoading] = useState(false);
  const [scopeOneFinancialYearId, setScopeOneFinancialYearId] = useState("");
  const [scopeTwoFinancialYearId, setScopeTwoFinancialYearId] = useState("");
  const [energyFinancialYearId, setEnergyFinancialYearId] = useState("");
  const [wasteFinancialYearId, setWasteFinancialYearId] = useState("");
  const [selectedReportTemplate, setSelectedReportTemplate] = useState("");
  const [selectedReportFinancialYearId, setSelectedReportFinancialYearId] = useState("");
  const [selectedReportPeriods, setSelectedReportPeriods] = useState([]);
  const [selectedReportLocations, setSelectedReportLocations] = useState([]);
  const [selectedReportCategories, setSelectedReportCategories] = useState([]);
  const [selectedModuleTemplateId, setSelectedModuleTemplateId] = useState(1);
  const [reportFinancialYearError, setReportFinancialYearError] = useState("");
  const [reportTemplateOptions, setReportTemplateOptions] = useState(STATIC_REPORT_TEMPLATE_OPTIONS);
  const [reportPdfLoading, setReportPdfLoading] = useState(false);
  const [reportWordLoading, setReportWordLoading] = useState(false);
  const [timePeriodOptions, setTimePeriodOptions] = useState([]);
  const [frequency, setFrequency] = useState(Userfrequency);
  const [permissionList, setPermissionList] = useState([]);
  
  // States for Searchable Dropdown
  const [isTabDropdownOpen, setIsTabDropdownOpen] = useState(false);
  const [tabSearchTerm, setTabSearchTerm] = useState("");

  const isMounted = useRef(true);

  // Find current tab details for the display button
  const activeTabData = tabs?.find(t => t.id === currentTab) || tabs?.[0] || { label: "Select Tab", icon: "📊" };

  // Filter tabs based on search input
  const filteredTabs = tabs?.filter(tab =>
    tab.visible &&
    tab.label.toLowerCase().includes(tabSearchTerm.toLowerCase())
  ) || [];

  useEffect(() => {
    const dashboardMenu = JSON.parse(localStorage.getItem("menu"));
    if (dashboardMenu) {
      const dashboardObject = dashboardMenu.find(item => item.caption === "Dashboard")?.permissions;
      setPermissionList(dashboardObject || []);
    }
    return () => { isMounted.current = false; };
  }, []);

  useEffect(() => {
    if (financialYearId) {
      setScopeOneFinancialYearId(String(financialYearId));
      setScopeTwoFinancialYearId(String(financialYearId));
      setEnergyFinancialYearId(String(financialYearId));
      setWasteFinancialYearId(String(financialYearId));
    }
  }, [financialYearId]);

  const [selectedLastYearPeriods, setSelectedLastYearPeriods] = useState(
    Object.keys(compareLastTimePeriods).map((key) => ({ label: key, value: key }))
  );
  const [selectedCurrentYearPeriods, setSelectedCurrentYearPeriods] = useState(
    Object.keys(compareTCurrentimePeriods).map((key) => ({ label: key, value: key }))
  );

  const handleBRSRDownload = () => {
    const url = "https://riu-bucket.s3.ap-south-1.amazonaws.com/uploads/Business%20responsibility%20and%20sustainability%20report.pdfBusiness%20responsibility%20and%20sustainability%20report.pdf";
    window.open(url, "_blank");
  };

  const handleBRSRGudeLineDownload = () => {
    const url = "https://riu-bucket.s3.ap-south-1.amazonaws.com/uploads/Business%20responsibility%20and%20sustainability%20reporting%20by%20listed%20entitiesAnnexure2_p.PDFBusiness%20responsibility%20and%20sustainability%20reporting%20by%20listed%20entitiesAnnexure2_p.PDF";
    window.open(url, "_blank");
  };

  useEffect(() => {
    getFinancialYear();
    getSource();
    getReportTemplateOptions();
  }, []);

  const getFinancialYear = async () => {
    const storedData = localStorage.getItem('financialYearData');
    if (storedData) {
      const data = JSON.parse(storedData);
      setFinancialYear(data);
      const lastEntry = data[data.length - 1];
      setSelectedYear(lastEntry.financial_year_value);
      setFinancialYearId(lastEntry.id);
      getFrequency(lastEntry.id);
    } else {
      const { isSuccess, data } = await apiCall(`${config.POSTLOGIN_API_URL_COMPANY}getFinancialYear`, {}, {}, "GET");
      if (isSuccess && isMounted.current) {
        localStorage.setItem('financialYearData', JSON.stringify(data.data));
        setFinancialYear(data.data);
        const lastEntry = data.data[data.data.length - 1];
        setSelectedYear(lastEntry.financial_year_value);
        setFinancialYearId(lastEntry.id);
        getFrequency(lastEntry.id);
      }
    }
  };

  const getSource = async () => {
    const { isSuccess, data } = await apiCall(`${config.POSTLOGIN_API_URL_COMPANY}getSource`, {}, {}, "GET");
    if (isSuccess && isMounted.current) {
      const locationArray = data?.data.map((item) => ({
        id: item.id,
        unitCode: item?.unitCode,
        location: `${item?.location?.area}, ${item?.location?.city}, ${item?.location?.state}, ${item?.location?.country}, ${item?.location?.zipCode}`,
      }));
      setMeterList(locationArray);
    }
  };

  const getReportTemplateOptions = async () => {
    const apiUrl = companyId == 331 ? `${config.POSTLOGIN_API_URL_COMPANY}bi-data/filters` :`${config.POSTLOGIN_API_URL_COMPANY}bi-graph/filters`
    try {
      const { isSuccess, data } = await apiCall(
        apiUrl,
        {},
        { dataSource: "REPORTING" },
        "GET"
      );

      if (isSuccess && data?.data && isMounted.current) {
        setReportTemplateOptions(buildReportTemplateOptionsFromFilters(data.data));
      }
    } catch (error) {
      console.error("Failed to load report template options:", error);
      if (isMounted.current) {
        setReportTemplateOptions(STATIC_REPORT_TEMPLATE_OPTIONS);
      }
    }
  };

  const getFrequency = async (fId) => {
    const { isSuccess, data } = await apiCall(`${config.POSTLOGIN_API_URL_COMPANY}getFrequency`, {}, { financialYearId: fId }, "GET");
    if (isSuccess && isMounted.current) setFrequency(data?.data);
  };

  useEffect(() => {
    if (meterList.length > 0 && selectedLocations.length === 0) {
      const initialLoc = meterList.length > 1 ? meterList[1] : meterList[0];
      const firstLocation = {
        value: initialLoc.unitCode || initialLoc.location,
        label: initialLoc.unitCode || initialLoc.location,
        unitCode: initialLoc.unitCode,
        id: initialLoc.id,
      };
      setSelectedLocations([firstLocation]);
      setLocationOption([firstLocation]);
    }
  }, [meterList]);

  const handleSelectionChange = (selectedOptions) => {
    const options = (typeof selectedOptions[0] === "object") ? selectedOptions : locationOptions.filter(item => selectedOptions.includes(item.value));
    setLocationOption(options);
    setSelectedLocations(options);
  };

  const handleLocationChangeSingle = (val) => {
    const options = locationOptions.filter((item) => item.value === val);
    setLocationOption(options);
    setSelectedLocations(options);
  };

  useEffect(() => {
    if (frequency) {
      let options = [];
      const baseOptions = start === 1 ? months : [...months.slice(start - 1), ...months.slice(0, start - 1)];
      
      if (frequency === "MONTHLY") {
        options = baseOptions.map((month, index) => ({ label: month, value: ((start + index - 1) % 12) + 1 }));
      } else if (frequency === "QUARTERLY" || frequency === "HALF_YEARLY") {
        const step = frequency === "QUARTERLY" ? 3 : 6;
        for (let i = start - 1; i < start + 11; i += step) {
          const sIdx = i % 12;
          const label = `${months[sIdx]} - ${months[(sIdx + step - 1) % 12]}`;
          options.push({ label, value: options.length + 1 });
        }
      } else if (frequency === "YEARLY") {
        options = [{ label: `${months[start - 1]} - ${months[(start - 2 + 12) % 12]}`, value: 1 }];
      }
      setTimePeriodOptions(options);
      if (options.length) {
        setSelectedPeriod([options[0]]);
        handlePeriodChangeSingle(options[0]);
      }
    }
  }, [frequency, start]);

  const calculateDateRange = (type, period, startingMonth, year) => {
    const sMonth = ((startingMonth - 1 + (period - 1) * type) % 12) + 1;
    const sYear = year + Math.floor((startingMonth - 1 + (period - 1) * type) / 12);
    const eMonth = ((sMonth - 1 + type) % 12) + 1;
    const eYear = sYear + Math.floor((sMonth - 1 + type) / 12);
    const format = (m, y) => `${y}-${m < 10 ? `0${m}` : m}`;
    return { fromDate: format(sMonth, sYear), toDate: format(eMonth, eYear) };
  };

  const handlePeriodChange = (selectedOptions) => {
    const options = (typeof selectedOptions[0] === "object") ? selectedOptions : timePeriodOptions.filter(item => selectedOptions.includes(item.value));
    setSelectedPeriod(options);
    const newTimePeriods = {};
    const year = parseInt(selectedYear.split("-")[0]) || new Date().getFullYear();
    let earliest = null, latest = null;

    options.forEach((period) => {
      let range;
      if (frequency === "HALF_YEARLY") range = calculateDateRange(6, period.value, start, year);
      else if (frequency === "QUARTERLY") range = calculateDateRange(3, period.value, start, year);
      else if (frequency === "MONTHLY") {
        const absIdx = months.indexOf(period.label);
        const relIdx = ((absIdx - (start - 1) + 12) % 12) + 1;
        range = calculateDateRange(1, relIdx, start, year);
      }
      else if (frequency === "YEARLY") range = calculateDateRange(12, 1, start, year);

      if (range) {
        newTimePeriods[period.label] = range.fromDate;
        if (!earliest || new Date(range.fromDate) < new Date(earliest)) earliest = range.fromDate;
        if (!latest || new Date(range.toDate) > new Date(latest)) latest = range.toDate;
      }
    });
    setFromDate(earliest); setToDate(latest); setTimePeriods(newTimePeriods);
  };

  const handlePeriodChangeSingle = (opt) => {
    if (selectedYear && opt) {
      const selected = (typeof opt === "object") ? opt : timePeriodOptions.find(i => i.value === opt);
      setSelectedPeriod([selected]);
      const year = parseInt(selectedYear.split("-")[0]) || new Date().getFullYear();
      let range;
      if (frequency === "HALF_YEARLY") range = calculateDateRange(6, selected.value, start, year);
      else if (frequency === "QUARTERLY") range = calculateDateRange(3, selected.value, start, year);
      else if (frequency === "MONTHLY") {
        const absIdx = months.indexOf(selected.label);
        const relIdx = ((absIdx - (start - 1) + 12) % 12) + 1;
        range = calculateDateRange(1, relIdx, start, year);
      }
      else if (frequency === "YEARLY") range = calculateDateRange(12, 1, start, year);

      if (range) {
        setFromDate(range.fromDate); setToDate(range.toDate);
        setTimePeriods({ [selected.value]: range.fromDate });
      }
    }
  };

  const locationOptions = meterList?.map(m => ({ value: m.unitCode || m.location, label: m.unitCode || m.location, unitCode: m.unitCode, id: m.id })) || [];
  const reportLocationOptions = meterList?.map((m) => ({
    value: m.id,
    label: m.unitCode || m.location,
  })) || [];
  const reportPeriodOptions = (timePeriodOptions || []).map((period) => ({
    value: period.label,
    label: period.label,
  }));
  const frameworkOptions = frameworkValue?.map(f => ({ label: f.title, value: f.id })) || [];


  const handleCloseFilter = () => setShowFilter(false);
  const handleOpenScopeOneModal = () => setShowScopeOneModal(true);
  const handleCloseScopeOneModal = () => setShowScopeOneModal(false);
  const handleOpenScopeTwoModal = () => setShowScopeTwoModal(true);
  const handleCloseScopeTwoModal = () => setShowScopeTwoModal(false);
  const handleOpenEnergyModal = () => setShowEnergyModal(true);
  const handleCloseEnergyModal = () => setShowEnergyModal(false);
  const handleOpenWasteModal = () => setShowWasteModal(true);
  const handleCloseWasteModal = () => setShowWasteModal(false);

  const handleScopeOneEmail = () => {
    alert("Send via email flow for Scope 1 will be connected here.");
    setShowScopeOneModal(false);
  };

  const handleScopeTwoEmail = () => {
    alert("Send via email flow for Scope 2 will be connected here.");
    setShowScopeTwoModal(false);
  };

  const handleScopeOnePdf = () => {
    if (!scopeOneFinancialYearId) return;
    const reportTab = window.open("", "_blank");
    setScopeOneLoading(true);

    apiCall(
      `${config.POSTLOGIN_API_URL_COMPANY}generateReport`,
      {},
      {
        financialYearId: Number(scopeOneFinancialYearId),
        frameworkId: 1,
        reportType: "PDF",
        templateType: "SCOPE1",
      },
      "POST"
    )
      .then(({ isSuccess, data }) => {
        if (!isSuccess || !data?.reportUrl) {
          if (reportTab) reportTab.close();
          return;
        }
        if (reportTab) reportTab.location.href = data.reportUrl;
        setShowScopeOneModal(false);
      })
      .catch((error) => {
        if (reportTab) reportTab.close();
        console.error("Error downloading Scope 1 report:", error);
      })
      .finally(() => setScopeOneLoading(false));
  };

  const handleScopeTwoPdf = () => {
    if (!scopeTwoFinancialYearId) return;
    const reportTab = window.open("", "_blank");
    setScopeTwoLoading(true);

    apiCall(
      `${config.POSTLOGIN_API_URL_COMPANY}generateReport`,
      {},
      {
        financialYearId: Number(scopeTwoFinancialYearId),
        frameworkId: 1,
        reportType: "PDF",
        templateType: "SCOPE2",
      },
      "POST"
    )
      .then(({ isSuccess, data }) => {
        if (!isSuccess || !data?.reportUrl) {
          if (reportTab) reportTab.close();
          return;
        }
        if (reportTab) reportTab.location.href = data.reportUrl;
        setShowScopeTwoModal(false);
      })
      .catch((error) => {
        if (reportTab) reportTab.close();
        console.error("Error downloading Scope 2 report:", error);
      })
      .finally(() => setScopeTwoLoading(false));
  };

  const handleEnergyPdf = () => {
    if (!energyFinancialYearId) return;
    const reportTab = window.open("", "_blank");
    setEnergyLoading(true);

    apiCall(
      `${config.POSTLOGIN_API_URL_COMPANY}generateReport`,
      {},
      {
        financialYearId: Number(energyFinancialYearId),
        frameworkId: 1,
        reportType: "PDF",
        templateType: "ENERGY",
      },
      "POST"
    )
      .then(({ isSuccess, data }) => {
        if (!isSuccess || !data?.reportUrl) {
          if (reportTab) reportTab.close();
          return;
        }
        if (reportTab) reportTab.location.href = data.reportUrl;
        setShowEnergyModal(false);
      })
      .catch((error) => {
        if (reportTab) reportTab.close();
        console.error("Error downloading Energy report:", error);
      })
      .finally(() => setEnergyLoading(false));
  };

  const handleWastePdf = () => {
    if (!wasteFinancialYearId) return;
    const reportTab = window.open("", "_blank");
    setWasteLoading(true);

    apiCall(
      `${config.POSTLOGIN_API_URL_COMPANY}generateReport`,
      {},
      {
        financialYearId: Number(wasteFinancialYearId),
        frameworkId: 1,
        reportType: "PDF",
        templateType: "WASTE",
      },
      "POST"
    )
      .then(({ isSuccess, data }) => {
        if (!isSuccess || !data?.reportUrl) {
          if (reportTab) reportTab.close();
          return;
        }
        if (reportTab) reportTab.location.href = data.reportUrl;
        setShowWasteModal(false);
      })
      .catch((error) => {
        if (reportTab) reportTab.close();
        console.error("Error downloading Waste report:", error);
      })
      .finally(() => setWasteLoading(false));
  };

  const handleSelectedTemplatePdf = () => {
    if (!selectedReportFinancialYearId) {
      setReportFinancialYearError("Please select financial year.");
      return;
    }
    if (
      !selectedReportTemplate ||
      selectedReportTemplate === "BRSR"
    ) return;
    const reportTab = window.open("", "_blank");
    setReportPdfLoading(true);
    const normalizedReportPeriods = (selectedReportPeriods || []).map(normalizeReportPeriodForApi);

    apiCall(
      `${config.POSTLOGIN_API_URL_COMPANY}generateReport`,
      {},
      {
        financialYearId: Number(selectedReportFinancialYearId),
        frameworkId: 1,
        reportType: "PDF",
        templateType: selectedReportTemplate,
        templateId: selectedModuleTemplateId,
        periods: normalizedReportPeriods,
        locationIds: selectedReportLocations,
        categories: selectedReportTemplate === "ENERGY" ? selectedReportCategories : [],
      },
      "POST"
    )
      .then(({ isSuccess, data }) => {
        if (!isSuccess || !data?.reportUrl) {
          if (reportTab) reportTab.close();
          return;
        }
        if (reportTab) reportTab.location.href = data.reportUrl;
        handleClose();
      })
      .catch((error) => {
        if (reportTab) reportTab.close();
        console.error(`Error downloading ${selectedReportTemplate} report:`, error);
      })
      .finally(() => setReportPdfLoading(false));
  };

  const handleSelectedTemplateWord = async () => {
    if (!selectedReportFinancialYearId) {
      setReportFinancialYearError("Please select financial year.");
      return;
    }
    if (
      !selectedReportTemplate ||
      selectedReportTemplate === "BRSR"
    ) return;

    try {
      setReportWordLoading(true);
      const currentUser = JSON.parse(localStorage.getItem("currentUser") || "null");
      const normalizedReportPeriods = (selectedReportPeriods || []).map(normalizeReportPeriodForApi);

      const response = await axios.post(
        `${config.POSTLOGIN_API_URL_COMPANY}generateReport/docx`,
        {
          financialYearId: Number(selectedReportFinancialYearId),
          frameworkId: 1,
          reportType: "DOCX",
          templateType: selectedReportTemplate,
          templateId: selectedModuleTemplateId,
          periods: normalizedReportPeriods,
          locationIds: selectedReportLocations,
          categories: selectedReportTemplate === "ENERGY" ? selectedReportCategories : [],
        },
        {
          responseType: "blob",
          withCredentials: true,
          headers: {
            Accept: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            userId: currentUser?.id,
          },
        }
      );

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });
      const contentDisposition = response.headers["content-disposition"] || "";
      const fileName =
        contentDisposition.match(/filename="([^"]+)"/i)?.[1] || `${selectedReportTemplate}_Report.docx`;
      const objectUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = objectUrl;
      link.download = fileName;
      link.rel = "noopener noreferrer";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(objectUrl);
      handleClose();
    } catch (error) {
      console.error(`Error downloading ${selectedReportTemplate} word report:`, error);
    } finally {
      setReportWordLoading(false);
    }
  };

  return (
    <div style={{ width: "100%" }}>
      <div className="refresh-info-banner">
        <i className="fa fa-info-circle mr-2"></i>
        Data is automatically synchronized and updated every 5 minutes.
      </div>
      <div className="color_div_Current mb-3">
        <div className="d-flex align-items-center justify-content-between w-100 px-2">
          
          {/* LEFT: Download & Module Switcher */}
          <div className="d-flex align-items-center gap-3">
            {permissionList.some(p => p.permissionCode === "DOWNLOAD_ESG_REPORT" && p.checked) && (
              <button
                className="esg_button_style"
                style={{ minWidth: "220px", justifyContent: "space-between", display: "flex", alignItems: "center" }}
                onClick={() => {
                  setSelectedReportTemplate("");
                  setSelectedReportFinancialYearId("");
                  setSelectedReportPeriods([]);
                  setSelectedReportLocations([]);
                  setSelectedReportCategories([]);
                  setSelectedModuleTemplateId(1);
                  setReportFinancialYearError("");
                  setShow(true);
                }}
              >
                <span><i className="fa fa-download mr-2"></i>Download Report</span>
              </button>
            )}

            
          

            {/* SEARCHABLE MODULE SELECTOR */}
            <div style={{ position: "relative" }}>
              <button 
                className="esg_button_style bg-white text-dark border"
                style={{ minWidth: "220px", justifyContent: "space-between", display: "flex", alignItems: "center" }}
                onClick={() => {
                  setIsTabDropdownOpen(!isTabDropdownOpen);
                  setTabSearchTerm(""); // Reset search on open
                }}
              >
                <span>{activeTabData.icon} {activeTabData.label}</span>
                <span style={{ fontSize: "10px" }}>{isTabDropdownOpen ? "▲" : "▼"}</span>
              </button>

              {isTabDropdownOpen && (
                <>
                  <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, zIndex: 998 }} onClick={() => setIsTabDropdownOpen(false)} />
                  <div style={{
                    position: "absolute", top: "105%", left: 0, zIndex: 999, background: "#fff",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)", borderRadius: "8px", width: "240px",
                    maxHeight: "400px", overflow: "hidden", border: "1px solid #eee", display: "flex", flexDirection: "column"
                  }}>
                    <div style={{ padding: "8px", borderBottom: "1px solid #eee" }}>
                      <input 
                        type="text"
                        autoFocus
                        placeholder="Search modules..."
                        className="form-control form-control-sm"
                        value={tabSearchTerm}
                        onChange={(e) => setTabSearchTerm(e.target.value)}
                      />
                    </div>
                    <div style={{ overflowY: "auto", flex: 1 }}>
                      {filteredTabs.length > 0 ? filteredTabs.map((tab) => (
                        <div
                          key={tab.id}
                          className="dropdown-item p-2 d-flex align-items-center"
                          style={{ cursor: "pointer", backgroundColor: currentTab === tab.id ? "#f0f7ff" : "transparent" }}
                          onClick={() => { setCurrentTab(tab.id); setIsTabDropdownOpen(false); }}
                        >
                          <span style={{ minWidth: "25px" }}>{tab.icon}</span> 
                          <span className="ml-2">{tab.label}</span>
                        </div>
                      )) : (
                        <div className="p-3 text-center text-muted small">No modules found</div>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
            
            {/* <button className="esg_button_style bg-light text-dark border" onClick={() => setShowFilter(true)}>
              <i className="fa fa-filter mr-1"></i> Filters
            </button> */}
          </div>

          {/* NEW: GRAPH TITLE SEARCH BAR */}
            <div className="search-container" style={{ position: "relative", minWidth: "250px" }}>
              <i className="fa fa-search" style={{ position: "absolute", left: "10px", top: "50%", transform: "translateY(-50%)", color: "#999" }}></i>
              <input 
                type="text"
                placeholder="Search graphs by title..."
                value={graphSearchTerm}
                onChange={(e) => setGraphSearchTerm(e.target.value)}
                style={{
                  padding: "6px 10px 6px 30px",
                  fontSize: "14px",
                  borderRadius: "20px",
                  border: "1px solid #ddd",
                  width: "100%",
                  outline: "none",
                  backgroundColor: "#f9fafb"
                }}
              />
              {graphSearchTerm && (
                <i 
                  className="fa fa-times-circle" 
                  onClick={() => setGraphSearchTerm("")}
                  style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", color: "#ccc", cursor: "pointer" }}
                ></i>
              )}
            </div>
          {/* RIGHT: Create & Sync */}
          <div className="d-flex align-items-center gap-2">
            <button className="esg_button_style" onClick={handleModal}>+ Create</button>
          </div>
        </div>
      </div>

      <Modal size="xl" show={show} onHide={handleClose} centered dialogClassName="report-config-dialog" contentClassName="report-config-modal">
        <Modal.Header closeButton className="report-config-header">
          <div className="report-config-title">ESG Report</div>
        </Modal.Header>
        <Modal.Body className="report-config-body text-center">
          <p className="report-config-subtitle mb-3">Configure and download the report you need</p>
          <Form.Group className="mb-4 text-left report-config-field">
            <Form.Label className="report-config-label">
              Report Type
            </Form.Label>
            <Form.Select
              value={selectedReportTemplate}
              onChange={(e) => {
                setSelectedReportTemplate(e.target.value);
                setSelectedReportFinancialYearId("");
                setSelectedReportPeriods([]);
                setSelectedReportLocations([]);
                setSelectedReportCategories([]);
                setSelectedModuleTemplateId(1);
                setReportFinancialYearError("");
              }}
              className="report-config-select"
            >
              <option value="">Select Report Type</option>
              {reportTemplateOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          {selectedReportTemplate === "BRSR" && (
            <>
              <div className="report-config-actions report-config-actions-brsr mb-3">
                <button onClick={handleBRSRDownload} className="new_button_style text-small">BRSR Format</button>
                <button onClick={handleBRSRGudeLineDownload} className="new_button_style text-small">BRSR Guidelines</button>
              </div>
              <div className="report-config-actions report-config-actions-brsr">
                <button className="new_button_style text-small" onClick={() => downloadPdf("WORD")} disabled={companyId !== "362"}>Word Report</button>
                <button className="new_button_style text-small" onClick={() => downloadPdf("PDF")} disabled={companyId !== "362"}>PDF Report</button>
              </div>
            </>
          )}

          {selectedReportTemplate && selectedReportTemplate !== "BRSR" && (
            <>
              <Row className="g-3 mb-4 align-items-start report-config-grid">
                <Col lg={4} md={12}>
                  <Form.Group className="text-left mb-0 report-config-field">
                    <Form.Label className="report-config-label">
                      Financial Year <span className="report-required-star">*</span>
                    </Form.Label>
                    <Form.Select
                      value={selectedReportFinancialYearId}
                      onChange={(e) => {
                        const selectedFyId = e.target.value;
                        setSelectedReportFinancialYearId(selectedFyId);
                        setSelectedReportPeriods([]);
                        setReportFinancialYearError("");
                        if (selectedFyId) {
                          const matchedFY = (financialYear || []).find((fy) => String(fy.id) === selectedFyId);
                          if (matchedFY?.financial_year_value) {
                            setSelectedYear(matchedFY.financial_year_value);
                          }
                          getFrequency(Number(selectedFyId));
                        }
                      }}
                      className={`report-config-select ${reportFinancialYearError ? "report-config-select-error" : ""}`}
                    >
                      <option value="">Select Financial Year</option>
                      {(financialYear || []).map((fy) => (
                        <option key={fy.id} value={fy.id}>
                          {`FY - ${fy.financial_year_value}`}
                        </option>
                      ))}
                    </Form.Select>
                    {reportFinancialYearError && (
                      <div className="report-field-error">{reportFinancialYearError}</div>
                    )}
                  </Form.Group>
                </Col>
                <Col lg={4} md={12}>
                  <MultiSelect
                    options={reportPeriodOptions}
                    selectedValues={selectedReportPeriods}
                    onChange={setSelectedReportPeriods}
                    placeholder="Select Period"
                    label="Period"
                    autoSelectAll={false}
                    containerStyle={{ minWidth: 0 }}
                    labelStyle={{ fontSize: "12px", letterSpacing: "1.4px", textTransform: "uppercase", color: "#6b7280", fontWeight: 700 }}
                  />
                </Col>
                <Col lg={4} md={12}>
                  <MultiSelect
                    options={reportLocationOptions}
                    selectedValues={selectedReportLocations}
                    onChange={setSelectedReportLocations}
                    placeholder="Select Location"
                    label="Location"
                    autoSelectAll={false}
                    containerStyle={{ minWidth: 0 }}
                    labelStyle={{ fontSize: "12px", letterSpacing: "1.4px", textTransform: "uppercase", color: "#6b7280", fontWeight: 700 }}
                  />
                </Col>
              </Row>
              {selectedReportTemplate === "ENERGY" && (
                <Row className="g-3 mb-4 align-items-start report-config-grid">
                  <Col lg={4} md={12}>
                    <MultiSelect
                      options={energyCategoryOptions}
                      selectedValues={selectedReportCategories}
                      onChange={setSelectedReportCategories}
                      placeholder="Select Category"
                      label="Category"
                      autoSelectAll={false}
                      containerStyle={{ minWidth: 0 }}
                      labelStyle={{ fontSize: "12px", letterSpacing: "1.4px", textTransform: "uppercase", color: "#6b7280", fontWeight: 700 }}
                    />
                  </Col>
                </Row>
              )}
              <ModuleReportTemplateSelector
                selectedTemplateId={selectedModuleTemplateId}
                onSelectTemplate={setSelectedModuleTemplateId}
                selectedReportTemplate={selectedReportTemplate}
                reportTemplateOptions={reportTemplateOptions}
              />
              <div className="report-config-actions report-config-actions-main mt-2">
                <button
                  className="new_button_style text-small"
                  onClick={handleSelectedTemplateWord}
                  disabled={reportWordLoading || reportPdfLoading}
                >
                  {reportWordLoading ? "Generating..." : "Download Word"}
                </button>
                <button
                  className="new_button_style text-small"
                  onClick={handleSelectedTemplatePdf}
                  disabled={reportWordLoading || reportPdfLoading}
                >
                  {reportPdfLoading ? "Generating..." : "Download PDF"}
                </button>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>

      <Modal size="md" show={showScopeOneModal} onHide={handleCloseScopeOneModal}>
        <Modal.Header closeButton>
          <label>Scope 1 Report</label>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label style={{ fontSize: "12px", fontWeight: 700, letterSpacing: "1.4px", textTransform: "uppercase", color: "#6b7280" }}>
              Financial Year
            </Form.Label>
            <Form.Select
              value={scopeOneFinancialYearId}
              onChange={(e) => setScopeOneFinancialYearId(e.target.value)}
              className="report-config-select"
            >
              {(financialYear || []).map((fy) => (
                <option key={fy.id} value={fy.id}>
                  {`FY - ${fy.financial_year_value}`}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <p className="text-center">Choose an action</p>
          <div className="d-flex justify-content-center gap-3">
            <button className="new_button_style text-small" onClick={handleScopeOneEmail}>
              Send via Email
            </button>
            <button className="new_button_style text-small" onClick={handleScopeOnePdf} disabled={scopeOneLoading || !scopeOneFinancialYearId}>
              {scopeOneLoading ? "Generating..." : "Download PDF"}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal size="md" show={showScopeTwoModal} onHide={handleCloseScopeTwoModal}>
        <Modal.Header closeButton>
          <label>Scope 2 Report</label>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label style={{ fontSize: "12px", fontWeight: 700, letterSpacing: "1.4px", textTransform: "uppercase", color: "#6b7280" }}>
              Financial Year
            </Form.Label>
            <Form.Select
              value={scopeTwoFinancialYearId}
              onChange={(e) => setScopeTwoFinancialYearId(e.target.value)}
              className="report-config-select"
            >
              {(financialYear || []).map((fy) => (
                <option key={fy.id} value={fy.id}>
                  {`FY - ${fy.financial_year_value}`}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <p className="text-center">Choose an action</p>
          <div className="d-flex justify-content-center gap-3">
            <button className="new_button_style text-small" onClick={handleScopeTwoEmail}>
              Send via Email
            </button>
            <button className="new_button_style text-small" onClick={handleScopeTwoPdf} disabled={scopeTwoLoading || !scopeTwoFinancialYearId}>
              {scopeTwoLoading ? "Generating..." : "Download PDF"}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal size="md" show={showEnergyModal} onHide={handleCloseEnergyModal}>
        <Modal.Header closeButton>
          <label>Energy Report</label>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label style={{ fontSize: "12px", fontWeight: 700, letterSpacing: "1.4px", textTransform: "uppercase", color: "#6b7280" }}>
              Financial Year
            </Form.Label>
            <Form.Select
              value={energyFinancialYearId}
              onChange={(e) => setEnergyFinancialYearId(e.target.value)}
              className="report-config-select"
            >
              {(financialYear || []).map((fy) => (
                <option key={fy.id} value={fy.id}>
                  {`FY - ${fy.financial_year_value}`}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <p className="text-center">Choose an action</p>
          <div className="d-flex justify-content-center gap-3">
            <button className="new_button_style text-small" onClick={handleEnergyPdf} disabled={energyLoading || !energyFinancialYearId}>
              {energyLoading ? "Generating..." : "Download PDF"}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal size="md" show={showWasteModal} onHide={handleCloseWasteModal}>
        <Modal.Header closeButton>
          <label>Waste Report</label>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label style={{ fontSize: "12px", fontWeight: 700, letterSpacing: "1.4px", textTransform: "uppercase", color: "#6b7280" }}>
              Financial Year
            </Form.Label>
            <Form.Select
              value={wasteFinancialYearId}
              onChange={(e) => setWasteFinancialYearId(e.target.value)}
              className="report-config-select"
            >
              {(financialYear || []).map((fy) => (
                <option key={fy.id} value={fy.id}>
                  {`FY - ${fy.financial_year_value}`}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <p className="text-center">Choose an action</p>
          <div className="d-flex justify-content-center gap-3">
            <button className="new_button_style text-small" onClick={handleWastePdf} disabled={wasteLoading || !wasteFinancialYearId}>
              {wasteLoading ? "Generating..." : "Download PDF"}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal size="lg" show={showFilter} onHide={handleCloseFilter}>
        <Modal.Header closeButton><div className="filter-title">Filters</div></Modal.Header>
        <Modal.Body style={{ minHeight: "50vh" }}>
          {currentTab !== 0 ? (
            <Tabs defaultActiveKey={keyTab} id="filter-tabs" className="mb-3 custom-tabs" onSelect={(k) => setKeyTab(k)}>
              {["combinedAll", "combined", "compare"].map(key => (
                <Tab eventKey={key} title={key.charAt(0).toUpperCase() + key.slice(1)} key={key}>
                   <Row className="g-2 p-3">
                      <Col md={4}><MultiSelect options={timePeriodOptions} selectedValues={selectedPeriod?.map(i => i.value) || []} onChange={handlePeriodChange} label="Period" /></Col>
                      <Col md={4}><MultiSelect options={locationOptions} selectedValues={selectedLocations?.map(i => i.value) || []} onChange={handleSelectionChange} label="Location" /></Col>
                      <Col md={4}><MultiSelect options={frameworkOptions} selectedValues={framework?.map(i => i.value) || []} onChange={(opts) => setFramework(opts)} label="Framework" /></Col>
                   </Row>
                </Tab>
              ))}
              <Tab eventKey="individual" title="Individual">
                <Row className="g-2 p-3">
                  <Col md={6}><PeriodsField value={selectedPeriod?.[0]?.value || ""} onChange={handlePeriodChangeSingle} options={timePeriodOptions} label="Period" /></Col>
                  <Col md={6}><LocationField value={selectedLocations?.[0]?.value || ""} onChange={handleLocationChangeSingle} options={locationOptions} label="Location" /></Col>
                </Row>
              </Tab>
              {currentTab !== 1 && (
                <Tab eventKey="compareToYear" title="Compare To Previous Year">
                  <Suspense fallback={<div className="p-5 text-center">Loading comparison data...</div>}>
                    <CompareTab {...{frequency, selectedPeriod, handlePeriodChange, timePeriodOptions, meterList, selectedLocations, handleSelectionChange, locationOptions, frameworkOptions, setSelectedLocations, framework, financialYear, calculateDateRange, setcompareLastTimePeriods, setcompareCurrentTimePeriods, compareLastTimePeriods, compareTCurrentimePeriods, selectedLastYearPeriods, setSelectedLastYearPeriods, selectedCurrentYearPeriods, setSelectedCurrentYearPeriods}} />
                  </Suspense>
                </Tab>
              )}
            </Tabs>
          ) : (
            <Row className="g-2 p-3">
               <Col md={4}><MultiSelect options={timePeriodOptions} selectedValues={selectedPeriod?.map(i => i.value) || []} onChange={handlePeriodChange} label="Period" /></Col>
               <Col md={4}><MultiSelect options={locationOptions} selectedValues={selectedLocations?.map(i => i.value) || []} onChange={handleSelectionChange} label="Location" /></Col>
               <Col md={4}><MultiSelect options={frameworkOptions} selectedValues={framework?.map(i => i.value) || []} onChange={(opts) => setFramework(opts)} label="Framework" /></Col>
            </Row>
          )}
        </Modal.Body>
      </Modal>

      <style>{`
        .refresh-info-banner {
          background-color: #f0f7ff;
          border: 1px solid #cce3ff;
          color: #004085;
          padding: 6px 15px;
          border-radius: 6px;
          font-size: 12px;
          margin-bottom: 10px;
          display: inline-flex;
          align-items: center;
          font-weight: 500;
        }

        .tab-dropdown-container {
          position: absolute; 
          top: 105%; 
          left: 0; 
          z-index: 999; 
          background: #fff;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15); 
          border-radius: 8px; 
          width: 240px;
          max-height: 400px; 
          overflow: hidden; 
          border: 1px solid #eee; 
          display: flex; 
          flex-direction: column;
        }

        .graph-search-input {
          padding: 6px 10px 6px 30px;
          fontSize: 14px;
          borderRadius: 20px;
          border: 1px solid #ddd;
          width: 100%;
          outline: none;
          background-color: #f9fafb;
        }

      `}</style>
    </div>
  );
};

export default DashboardHeader;
